import React, { useState, useEffect, lazy, Suspense } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Hero from "../../components/hero/HeroLight";
// AnimatedCursor removed — v2.2.0 has a performance bug on input hover (100% CPU)

// Lazy load non-home sections — they load only when the tab is first clicked
const Index     = lazy(() => import("../../components/about/index"));
const Portfolio = lazy(() => import("../../components/portfolio/DomainPortfolio"));
const Contact   = lazy(() => import("../../components/Contact"));
const Address   = lazy(() => import("../../components/Address"));
const Social    = lazy(() => import("../../components/Social"));

const menuItem = [
  { icon: "fa-home", menuName: "Home" },
  { icon: "fa-user", menuName: "About" },
  { icon: "fa-briefcase", menuName: "Portfolio" },
  { icon: "fa-envelope-open", menuName: "Contact" },
  // { icon: "fa-photo", menuName: "Gallery" }
  // { icon: "fa-comments", menuName: "Blog" },
];

const LoadingFallback = () => <div style={{ minHeight: "60vh" }}></div>;

const HomeLight = (props) => {
  // Resolve initial tab from URL exactly once. Calling setTabIndex() in render = infinite loop.
  const [defaultIndex, setTabIndex] = useState(() => {
    const path = window.location.pathname;
    if (path === '/about' || path === '/about/')         return 1;
    if (path === '/portfolio' || path === '/portfolio/') return 2;
    if (path === '/contact' || path === '/contact/')     return 3;
    return 0;
  });
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    if (theme === "light") {
      document.body.classList.add("light");
    } else {
      document.body.classList.remove("light");
    }
  }, [theme]);

  // Clean up URL exactly once on mount
  useEffect(() => {
    window.history.replaceState('', '', '/');
  }, []);

  // useEffect(() => {
  //   RestClient.get(process.env.REACT_APP_WP_URL+"/posts")
  //   .then(result => {
  //     if(result.status){
  //       let posts = result.data;
  //       props.addBlogsHandler(posts)
  //     }
  //   });
  // }, [])

  return (
    <div className="green">
      {/* Modern Theme Switcher */}
      <div
        className="theme-switcher-btn"
        onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
        style={{
          position: 'fixed',
          top: '25px',
          right: '25px',
          width: '64px',
          height: '32px',
          borderRadius: '30px',
          backgroundColor: theme === 'light' ? '#e2e8f0' : '#1e293b',
          display: 'flex',
          alignItems: 'center',
          padding: '4px',
          cursor: 'pointer',
          zIndex: 9999,
          boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.1)',
          transition: 'background-color 0.4s ease'
        }}
        title={`Switch to ${theme === 'light' ? 'Dark' : 'Light'} Mode`}
      >
        <div style={{
          width: '26px',
          height: '26px',
          borderRadius: '50%',
          backgroundColor: theme === 'light' ? '#ffffff' : '#0f172a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
          transform: `translateX(${theme === 'light' ? '0' : '30px'})`,
          transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}>
          <i
            className={theme === 'light' ? "fa fa-sun-o" : "fa fa-moon-o"}
            style={{
              color: theme === 'light' ? '#f59e0b' : '#ffffff',
              fontSize: '14px',
              transition: 'all 0.4s ease'
            }}
          ></i>
        </div>
      </div>

      <Tabs selectedIndex={defaultIndex} onSelect={index => { setTabIndex(index); window.scrollTo(0, 0); }}>
        <div className="header">
          <TabList className=" icon-menu  revealator-slideup revealator-once revealator-delay1">
            {menuItem.map((item, i) => (
              <Tab className="icon-box" key={i}>
                <i className={`fa ${item.icon}`}></i>
                <h2>{item.menuName}</h2>
              </Tab>
            ))}
          </TabList>
        </div>
        {/* End Menu Content */}

        <div className="tab-panel_list">
          {/* Hero Content Starts */}
          <TabPanel className="home ">
            <div
              className="container-fluid main-container container-home p-0 "
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div className="color-block d-none d-lg-block"></div>
              <Hero />
            </div>
          </TabPanel>
          {/* Hero Content Ends */}

          {/* About Content Starts */}
          <TabPanel className="about">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>ABOUT <span>ME</span></h1>
                <span className="title-bg">Resume</span>
              </div>
              <Suspense fallback={<LoadingFallback />}>
                <Index />
              </Suspense>
            </div>
          </TabPanel>
          {/* About Content Ends */}

          {/* Portfolio Content Starts */}
          <TabPanel className="portfolio">
            <div className="title-section text-left text-sm-center" data-aos="fade-up" data-aos-duration="1200">
              <h1>my <span>portfolio</span></h1>
              <span className="title-bg">works</span>
            </div>
            <div className="container grid-gallery main-content" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
              <Suspense fallback={<LoadingFallback />}>
                <Portfolio />
              </Suspense>
            </div>
          </TabPanel>
          {/* Portfolio Content Ends */}

          {/* Contact Content Starts */}
          <TabPanel className="contact">
            <div className="title-section text-left text-sm-center" data-aos="fade-up" data-aos-duration="1200">
              <h1>get in <span>touch</span></h1>
              <span className="title-bg">contact</span>
            </div>
            <div className="container" data-aos="fade-up" data-aos-duration="1200">
              <div className="row">
                <div className="col-12 col-lg-4">
                  <h3 className="text-uppercase custom-title mb-0 ft-wt-600 pb-3">Don't be shy !</h3>
                  <p className="open-sans-font mb-4">
                    Feel free to get in touch with me. I am always open to
                    discussing new projects, creative ideas or opportunities to
                    be part of your visions.
                  </p>
                  <Suspense fallback={null}>
                    <Address />
                    <Social />
                  </Suspense>
                </div>
                <div className="col-12 col-lg-8">
                  <Suspense fallback={<LoadingFallback />}>
                    <Contact />
                  </Suspense>
                </div>
              </div>
            </div>
          </TabPanel>
          {/* Contact Content Ends */}

          {/* Gallery Content Starts */}
          {/* <TabPanel className="gallery">
            <div
              className="title-section text-left text-sm-center"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <h1>
                Visual <span>Showcase</span>
              </h1>
              <span className="title-bg">My Gallery</span>
            </div>
            <div
              className="container"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <Gallery />
            </div>
          </TabPanel> */}
          {/* End grid gallery */}
          {/* Portfolio Content Ends */}

          {/* Blog Content Starts */}
          {/* <TabPanel className="blog">
            <div
              className="title-section text-left text-sm-center "
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <h1>
                my <span>blog</span>
              </h1>
              <span className="title-bg">posts</span>
            </div>
            <div
              className="container"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div className="row pb-50">
                <Blog />
              </div>
            </div>
          </TabPanel> */}
          {/* Blog Content Ends */}
        </div>
      </Tabs>
    </div>
  );
};

export default HomeLight;
